// extracted by mini-css-extract-plugin
export default {"commonBlock":"style_commonBlock__6wdQ8"};